import paths from 'constants/paths'

export const NavigationItems = {
  Pixion: {
    src: '/assets/navigation/pixion-logo.svg',
    srcMobile: '/assets/navigation/pixion-mobile.svg',
    srcTablet: '/assets/navigation/pixion-tablet.svg',
    key: 'pixion',
    displayName: '',
    href: '',
  },
  Work: {
    src: '/assets/navigation/work.svg',
    srcMobile: '/assets/navigation/work-mobile.svg',
    srcTablet: '/assets/navigation/work-tablet.svg',
    key: 'work',
    displayName: 'Work',
    href: paths.work,
  },
  About: {
    src: '/assets/navigation/about.svg',
    srcMobile: '/assets/navigation/about-mobile.svg',
    srcTablet: '/assets/navigation/about-tablet.svg',
    key: 'about',
    displayName: 'About',
    href: paths.about,
  },
  Blog: {
    src: '/assets/navigation/blog.svg',
    srcMobile: '/assets/navigation/blog-mobile.svg',
    srcTablet: '/assets/navigation/blog-tablet.svg',
    key: 'blog',
    displayName: 'Blog',
    href: paths.blog,
  },
  Careers: {
    src: '/assets/navigation/careers.svg',
    srcMobile: '/assets/navigation/careers-mobile.svg',
    srcTablet: '/assets/navigation/careers-tablet.svg',
    key: 'careers',
    displayName: 'Careers',
    href: paths.careers,
  },
  Contact: {
    src: '/assets/navigation/contact.svg',
    srcMobile: '/assets/navigation/contact-mobile.svg',
    srcTablet: '/assets/navigation/contact-tablet.svg',
    key: 'contact',
    displayName: 'Contact',
    href: paths.contact,
  },
}
